import React from "react";
import styled from "styled-components";
import { CaptionText, CaptionsContainer, StyledVideoContainer } from "@telus/opus-component-library/video-player";

const ShakaPlayerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;

  ${StyledVideoContainer} {
    width: 100%;
    height: 100%;
  }
  ${CaptionsContainer} {
    position: absolute;
    bottom: 20%;
  }

  ${CaptionText} {
    font: 24px monospace;
  }
`;

export default ShakaPlayerContainer;
